module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannapro.ver2_0_2.gif?437be467";